$(document).on("turbolinks:load", () => {
  $('.review__icon').click(function(){
    $('.review__icon').removeClass('active');
    $(this).addClass('active');
    $('#review_binary_score').val($(this).attr('data-val'));
  });
});